var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewRoutes)?_c('section',{staticStyle:{"height":"calc(100vh - 70px)"}},[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.rutas.filter(item => item.enable == true)}}),_c('div',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 128px)"}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }